import { Message } from "@/types/message";
import { normalizeQuestion } from "./questionNormalizer";
import { isSimpleFollowUp } from "./followUpDetector";
import { debugLogger } from "@/utils/debugLogger";

// Create a hash from conversation context for context-aware caching
export const createContextHash = (messages: Message[], currentQuestion: string): string => {
  // Find the most recent user query that generated a list (not a follow-up)
  const recentUserQueries = messages
    .filter(msg => !msg.isBot && !msg.error)
    .slice(-5); // Look at last 5 user messages
  
  // Find the base query (non-follow-up) that this might be referring to
  let baseQuery = '';
  for (let i = recentUserQueries.length - 1; i >= 0; i--) {
    const query = normalizeQuestion(recentUserQueries[i].content);
    // If it's not a follow-up pattern, it's likely the base query
    if (!isSimpleFollowUp(query)) {
      baseQuery = query;
      break;
    }
  }
  
  // Include the base query context + recent conversation
  const recentMessages = messages
    .slice(-2) // Just last 2 messages for immediate context
    .filter(msg => !msg.error)
    .map(msg => `${msg.isBot ? 'bot' : 'user'}:${normalizeQuestion(msg.content)}`)
    .join('|');
  
  // Create context string with base query and immediate context
  const contextString = `base:${baseQuery}|recent:${recentMessages}|current:${normalizeQuestion(currentQuestion)}`;
  
  debugLogger.log(`🔍 Context string: ${contextString}`);
  
  // Simple hash function
  let hash = 0;
  for (let i = 0; i < contextString.length; i++) {
    const char = contextString.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  return Math.abs(hash).toString(16);
};